import { atom } from "recoil";
export const PacksVoAtom = atom({
  key: "PacksVoAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
